export default __webpack_public_path__ + "e1af516fb5a9691765df39d89414fdfa.png";